export type SendToLaptopOutcome = "sent" | "signin" | "error";

/**
 * Client half of "Kirim ke laptop": POSTs the current page to
 * `/api/me/send-to-laptop` and maps the response to what the UI shows.
 * A 429 means an earlier tap already sent it, so it reads as "sent".
 */
export async function requestSendToLaptop(
	locale: string,
	extra?: {
		jobId?: string;
		draft?: { to: string; subject: string; body: string };
	},
): Promise<SendToLaptopOutcome> {
	try {
		const res = await fetch("/api/me/send-to-laptop", {
			method: "POST",
			headers: { "content-type": "application/json" },
			credentials: "same-origin",
			body: JSON.stringify({
				locale,
				path: `${window.location.pathname}${window.location.search}`,
				...(extra?.jobId ? { jobId: extra.jobId } : {}),
				...(extra?.draft ? { draft: extra.draft } : {}),
			}),
		});
		if (res.ok) return "sent";
		if (res.status === 401) return "signin";
		if (res.status === 429) return "sent";
		return "error";
	} catch {
		return "error";
	}
}
